import ItFlag from './../assets/images/IT.png'
import UsFlag from './../assets/images/US.png'
import GbFlag from './../assets/images/GB.png'
import DeFlag from './../assets/images/DE.png'
import FrFlag from './../assets/images/FR.png'

export const CountrySources = [
    'all',
    'italy',
    'united-states',
    'united-kingdom',
    'france',
    'germany'
]

export const CountrySourcesIcons = {
    'italy': ItFlag,
    'united-states': UsFlag,
    'united-kingdom': GbFlag,
    'france': FrFlag,
    'germany': DeFlag
}

export const getCountrySourceMenuItems = (tFunc) => {
    const countrySourceMenuItems = CountrySources.map((country, index) => {
        return {value: country, label: tFunc(`sources.${country}`), icon: CountrySourcesIcons[country]}
    })

    return countrySourceMenuItems
}


// WEBPACK FOOTER //
// ./src/libs/CountrySources.js